module.exports = __webpack_public_path__ + "img/ostado-tutor-signup-why1.9880776.gif";